import React, { useState } from "react";
import {
    MDBSideNavCollapse,
    MDBSideNavItem,
    MDBSideNavLink,
    MDBSelect
} from "mdb-react-ui-kit";

const FilterLegislatureSelect = ({
                               legislatures,
                               filterLegislature,
                               setFilterLegislature,
                           }) => {
    const [legislatureCollapse, setLegislatureCollapse] = useState(false);

// Filter out the legislature where text equals "68"
const legislatureOptions = legislatures
    .map((legislature) => ({
      text: legislature.ordinals,
      value: legislature.id,
    }))
    .filter((option) => option.text !== "68"); // Hide option with text "68" for now, as these should not show up yet

    return (
        <MDBSideNavItem>
            <MDBSideNavLink
                className="accordion-button"
                icon="angle-down"
                shouldBeExpanded={legislatureCollapse}
                onClick={() => setLegislatureCollapse(!legislatureCollapse)}
            >
                Interim
            </MDBSideNavLink>
            <MDBSideNavCollapse open={legislatureCollapse}>
                <li className="p-3">
                    <MDBSelect
                        data={legislatureOptions}
                        value={filterLegislature?.id || ""}
                        search
                        label="Select Legislature Term"
                        onChange={(value) => {
                            setFilterLegislature(
                                legislatures.find((item) => item.id === value.value)
                            );
                        }}
                    />
                </li>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default FilterLegislatureSelect;